import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import * as _ from 'lodash';
import { Utility } from '../../utility/utility';
import { IconWarningComponent } from 'src/app/shared/directives/icon-warning/icon-warning.component';

@Component({
  selector: 'app-filter-box',
  templateUrl: './filter-box.component.html',
  styleUrls: ['./filter-box.component.scss']
})
export class FilterBoxComponent implements OnInit {
  // filter and sort
  @Input() showFilter = false;
  @Input() sltdField = '';
  @Input() sltdId = 0;
  @Input() arCurrData = [];
  @Input() arCol = [];
  @Input() colSltedData: any = [];
  @Input() colSltedFilter: any = [];
  @Input() pos: any = {};
  @Input() sortFlag =  '';
  @Input() IsChange = false;
  @Input() status = '1';
  @Output() eventFilterData = new EventEmitter();
  @ViewChild('iconWarning') iconWarning: IconWarningComponent;
  keySrh = '';
  arSF: any = [];
  filterFlag = false;
  lstData: any = [];
  constructor(
    public util: Utility) { }

  ngOnInit(): void {
  }
  filter(event: any) {
    // tslint:disable-next-line:only-arrow-functions
    this.colSltedFilter = _.filter(this.colSltedData, function(item) {
      return item.name.startsWith(event);
    });
  }
  checkFilter(value){
    this.IsChange = true;
    let check = true;
    if (value.IsShow){
      check = false;
    }
    for (const item of this.arCurrData) {
      for (const it of value.lstCode){
        if (item[this.sltdField] === it){
          item.IsShow = check;
        }
      }
    }
    this.dataFilter(this.arCurrData);
  }
  dataFilter(data){
    this.lstData = [];
    for (const item of data) {
      if (item.IsShow){
        this.lstData.push(item);
      } else if (!this.util.isNullOrEmpty(item.Checked) && item.Checked){
        item.Checked = false;
      }
    }
    const obj = {
      data: this.lstData,
      sortFlag: this.sortFlag,
      showFilter: this.showFilter,
      arCol: this.arCol,
      IsChange: true,
      arCurrData: this.arCurrData
    };
    this.eventFilterData.emit(obj);
  }
  getSortBy(value, id, field){
    this.IsChange = true;
    this.sortFlag = value;
    const checkS = this.arSF.filter(x => x.name === field);
    if (checkS.length > 0){
      // tslint:disable-next-line:only-arrow-functions
      this.arSF = _.remove(this.arSF, function(n) { return n.name === field; });
    }
    // tslint:disable-next-line:object-literal-shorthand
    const obj = { sort: value, id: id, field: field };
    this.arSF.unshift(obj);
    this.sortBy(this.arSF);
    for (const item of this.arCol) {
      if (field === item.name){
        item.sort = value;
      }
    }
  }
  sortBy(value){
    // tslint:disable-next-line:one-variable-per-declaration
    const arF = [], arS = [];
    for (const item of value) {
      if (item.sort !== ''){
        arF.push(item.field);
        arS.push(item.sort);
      }
    }
    const data = _.orderBy(this.arCurrData, arF, arS);
    this.dataFilter(data);
  }
  closeFilter(){
    this.keySrh = '';
    this.sortFlag = '';
    this.showFilter = false;
    if (this.IsChange){
      const obj = {
        data: this.lstData,
        sortFlag: this.sortFlag,
        showFilter: this.showFilter,
        arCol: this.arCol,
        IsChange: false,
        arCurrData: this.arCurrData
      };
      this.eventFilterData.emit(obj);
    }
  }
}
